import { IkeToken } from '@ikegps/core-api';
import { T } from '../../i18n';
import { Services } from '../../services/index';
import { CurrentState } from '../../state/page.state';
import { CollectionMoveToDepartmentModal } from '../collection.move.modal/collection.move.modal';

export const CollectionMoveToDepartmentCtrl = {
	canMove(): boolean {
		if (
			!Services.Token.has(IkeToken.TAG_JOB_UPDATE) ||
			!(Services.Token.has(IkeToken.FEATURE_COLLECTION_MOVE) || Services.Token.has(IkeToken.FEATURE_GROUP_IKE_ANALYZE))
		) {
			return false;
		}

		return Services.Department.moveableDepartments().length > 0;
	},

	showMoveModal(): void {
		const collections = CurrentState.Tag.collections;
		const modal = new CollectionMoveToDepartmentModal(
			{
				title: T.COLLECTION_MOVE_TITLE,
				confirm: T.COLLECTION_MOVE,
				success: {
					key: T.COLLECTION_MOVE_SUCCESS,
					attrs: {
						count: collections.length,
					},
				},
			},
			collections
		);

		modal.open();
	},
};
